import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-spacer",
  templateUrl: "./spacer.component.html",
  styleUrls: ["./spacer.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class SpacerComponent {
  @Input() mobile = 0;

  @Input() desktop = 0;
}
